import React, { useEffect } from 'react';
import { useIsMobile } from '@/utils/useIsMobile';
import { Sheet } from 'react-modal-sheet';
import Modal from '@/ui/modal/Modal';

export const Pocket = ({
	defaultOpen,
	open,
	onOpenChange,
	title,
	leftComponent,
	onClose,
	fuckingBig,
	children,
}) => {
	const isMobile = useIsMobile();

	if (!isMobile && !open) {
		return null;
	}

	// const childrenWithProps = React.Children.map(children, child => {
	// 	if (!React.isValidElement(child)) return child;
	// 	return React.cloneElement(child, { isMobile, onClose });
	// });

	return isMobile ? (
		// <Drawer.Root
		// 	repositionInputs={false}
		// 	defaultOpen={defaultOpen}
		// 	open={open}
		// 	onOpenChange={onOpenChange}
		// >
		<Sheet detent='content' isOpen={open} onClose={onOpenChange}>
			<Sheet.Container
				style={{
					borderTopRightRadius: 32,
					borderTopLeftRadius: 32,
					background: 'rgb(250,250,250',
				}}
			>
				<Sheet.Header />
				<Sheet.Content disableDrag={false}>
					<div className='pt-0 pb-1'>
						<div className='mb-4 h-10.5 w-full self-stretch border-b-2 border-b-[#14c9cb] bg-[rgb(250,250,250)]'>
							{leftComponent && <div className='absolute top-1 left-5'>{leftComponent}</div>}
							<div className='self-center text-center text-lg font-semibold'>{title}</div>
						</div>

						<div className='flex flex-col overflow-y-auto px-3 pb-2'>{children}</div>
					</div>
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop onTap={onClose} />
		</Sheet>
	) : (
		<Modal fuckingBig={fuckingBig} title={title} leftComponent={leftComponent} onClose={onClose}>
			{children}
		</Modal>
	);
};
